import {
  Stethoscope,
  Calculator,
  GraduationCap,
  Rocket,
  Building2,
  ShoppingCart,
  Briefcase,
} from "lucide-react";

// Illustrative system concepts per industry — not claims of past work.
export const industries = [
  {
    id: "healthcare",
    icon: Stethoscope,
    label: "Healthcare & Clinics",
    system: ["Website", "Patient CRM", "Appointment Automation"],
    note: "Enquiries flow into a patient pipeline, reminders run themselves, and the front desk works from one screen.",
  },
  {
    id: "ca-finance",
    icon: Calculator,
    label: "CA & Finance",
    system: ["Website", "Lead Management", "Client Portal", "Reporting"],
    note: "Clients upload documents to a portal, deadlines track themselves, and status reports build automatically.",
  },
  {
    id: "coaches",
    icon: GraduationCap,
    label: "Coaches & Consultants",
    system: ["Website", "Booking System", "CRM", "Email Automation"],
    note: "Discovery calls book themselves, follow-ups go out on time, and no lead goes cold by accident.",
  },
  {
    id: "founders",
    icon: Rocket,
    label: "Founders & Startups",
    system: ["Website", "CRM", "Automation", "Dashboard"],
    note: "From first landing page to an operating system for the whole company — built to scale with you.",
  },
  {
    id: "real-estate",
    icon: Building2,
    label: "Real Estate",
    system: ["Website", "Lead CRM", "Site-Visit Pipeline", "Reports"],
    note: "Every portal and website enquiry lands in one pipeline, agents get nudged, and managers see it all live.",
  },
  {
    id: "ecommerce",
    icon: ShoppingCart,
    label: "E-commerce",
    system: ["Storefront", "Inventory Sync", "Order Automation", "Analytics"],
    note: "Storefront, inventory and orders in one loop — with abandoned carts recovered automatically.",
  },
  {
    id: "professional",
    icon: Briefcase,
    label: "Professional Services",
    system: ["Website", "Client Portal", "Document Automation", "Reports"],
    note: "Proposals, documents and approvals move through a system instead of an inbox.",
  },
];
